module.exports = __webpack_public_path__ + "img/shop7-7.ae312935.png";